export default "__VITE_ASSET__a9d54051__"